<template>
    <div class="Invoice">
        <navbar :isHiddenlogin="false"></navbar>
        <step-bar :step="3"></step-bar>
        <div class="invoice-container">
            <div class="selected-invoice">
                <span>选择发票抬头：</span>
                <button class="add-btn" @click="openAddModal">新增发票抬头</button>
            </div>
            <div class="tab-container">
                <div class="tabs">
                    <div :class="['tab', tabType === 'personal' ? 'active' : '']" @click="tabType = 'personal'">个人</div>
                    <div :class="['tab', tabType === 'company' ? 'active' : '']" @click="tabType = 'company'">单位</div>
                </div>
                <div class="tab-tips">
                    <p>书籍签收成功后，系统将于7个工作日内开具发票并发送至预留邮箱。</p>
                    <p>咨询电话：010-88484118-815/855</p>
                </div>
            </div>
            <div class="invoice-list">
                <!-- 表头 -->
                <div class="invoice-header"
                    v-if="(tabType === 'personal' && personalList.length > 0) || (tabType === 'company' && companyList.length > 0)">
                    <div class="col name">{{ getNameColumnTitle() }}</div>
                    <div class="col email">{{ getEmailColumnTitle() }}</div>
                    <div class="col phone">{{ getPhoneColumnTitle() }}</div>
                    <div class="col radio-col">选择</div>
                </div>

                <div v-if="tabType === 'personal'">
                    <div v-if="personalList.length === 0" class="empty-state">
                        <div class="empty-text">暂无个人发票信息</div>
                        <button class="fill-invoice-btn" @click="openAddModal">填写个人发票</button>
                    </div>
                    <div v-else>
                        <div v-for="(item, idx) in personalList" :key="item.id" class="invoice-item"
                            @click="selectPersonal(idx)">
                            <div class="col name">{{ item.companyName }}</div>
                            <div class="col email invoice-container-left">{{ item.receiveEmail }}</div>
                            <div class="col phone invoice-container-left">{{ item.phoneNumber }}</div>
                            <div class="col radio-col">
                                <label class="custom-radio">
                                    <input type="radio" :checked="idx === selectedPersonalIdx"
                                        @change="selectPersonal(idx)" name="personal-default" />
                                    <span class="radio-mark">
                                        <svg v-if="idx === selectedPersonalIdx" width="22" height="22"
                                            viewBox="0 0 22 22">
                                            <circle cx="11" cy="11" r="10" fill="#1677ff" />
                                            <polyline points="6,12 10,16 16,7" fill="none" stroke="#fff"
                                                stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <svg v-else width="22" height="22" viewBox="0 0 22 22">
                                            <circle cx="11" cy="11" r="10" fill="#fff" stroke="#d9d9d9"
                                                stroke-width="2" />
                                        </svg>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div v-if="companyList.length === 0" class="empty-state">
                        <div class="empty-text">暂无单位发票信息</div>
                        <button class="fill-invoice-btn" @click="openAddModal">填写单位发票</button>
                    </div>
                    <div v-else>
                        <div v-for="(item, idx) in companyList" :key="item.id" class="invoice-item"
                            @click="selectCompany(idx)">
                            <div class="col name invoice-container-left" style="">{{ item.companyName }}</div>
                            <div class="col email invoice-container-left">{{ item.receiveEmail }}</div>
                            <div class="col Tax invoice-container-left">{{ item.companyTax }}</div>
                            <div class="col radio-col">
                                <label class="custom-radio">
                                    <input type="radio" :checked="idx === selectedCompanyIdx"
                                        @change="selectCompany(idx)" name="company-default" />
                                    <span class="radio-mark">
                                        <svg v-if="idx === selectedCompanyIdx" width="22" height="22"
                                            viewBox="0 0 22 22">
                                            <circle cx="11" cy="11" r="10" fill="#1677ff" />
                                            <polyline points="6,12 10,16 16,7" fill="none" stroke="#fff"
                                                stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <svg v-else width="22" height="22" viewBox="0 0 22 22">
                                            <circle cx="11" cy="11" r="10" fill="#fff" stroke="#d9d9d9"
                                                stroke-width="2" />
                                        </svg>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <div class="btn-group">
                        <button class="cancel-btn" @click="handleNoInvoice">暂不开票</button>
                        <button class="confirm-btn" @click="next"
                            :disabled="(tabType === 'personal' && personalList.length === 0) || (tabType === 'company' && companyList.length === 0)">
                            确认开票
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 新增发票抬头弹窗 -->
        <div v-if="showAddModal" class="modal-mask">
            <div class="modal-content">
                <h3 class="modal-title">新增{{ tabType === 'personal' ? '个人' : '单位' }}发票抬头</h3>
                <form @submit.prevent="handleSave">
                    <div v-if="tabType === 'personal'">
                        <div class="form-row">
                            <div class="input-group">
                                <label><span class="required">*</span> 姓名：</label>
                                <input v-model="personalFrom.companyName" placeholder="请输入姓名..." />
                            </div>
                            <div class="error-tip" v-if="error.companyName">{{ error.companyName ? error.companyName :
                                '\u00A0' }}</div>
                        </div>
                        <div class="form-row">
                            <div class="input-group">
                                <label><span class="required">*</span> 手机号：</label>
                                <input v-model="personalFrom.phoneNumber" placeholder="请输入手机号..." maxlength="11" />
                            </div>
                            <div class="error-tip" v-if="error.phoneNumber">{{ error.phoneNumber ? error.phoneNumber :
                                '\u00A0' }}</div>
                        </div>
                        <div class="form-row">
                            <div class="input-group">
                                <label><span class="required">*</span> 邮箱：</label>
                                <input v-model="personalFrom.receiveEmail" placeholder="请输入邮箱..." />
                            </div>
                            <div class="error-tip" v-if="error.receiveEmail">{{ error.receiveEmail ? error.receiveEmail
                                : '\u00A0' }}</div>
                        </div>
                        <div class="form-row checkbox-row">
                            <div class="input-group">
                                <label>是否默认：</label>
                                <label class="checkbox-label label-width">
                                    <input type="checkbox" v-model="personalFrom.isDefault" /> <span>作为默认发票</span>
                                </label>
                            </div>
                            <div class="error-tip"></div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="form-row">
                            <div class="input-group">
                                <label>发票抬头：</label>
                                <span>企业单位</span>
                            </div>
                            <div class="error-tip"></div>
                        </div>
                        <!-- <div class="form-row radio-row">
                            <div class="input-group">
                                <label>发票类型：</label>
                                <label class="radio-label"><input type="radio" value="1"
                                        v-model="addForm.invoiceType" /> <span>普票</span></label>
                                <label class="radio-label"><input type="radio" value="2"
                                        v-model="addForm.invoiceType" /> <span>专票</span></label>
                            </div>
                        </div> -->
                        <div class="form-row">
                            <div class="input-group">
                                <label><span class="required">*</span> 公司名称：</label>
                                <input v-model="addForm.companyName" placeholder="请输入公司名称..." />
                            </div>
                            <div class="error-tip" v-if="error.companyName">{{ error.companyName ? error.companyName :
                                '\u00A0' }}</div>
                        </div>
                        <div class="form-row">
                            <div class="input-group">
                                <label><span class="required">*</span> 公司税号：</label>
                                <input v-model="addForm.companyTax" placeholder="请输入公司税号..." />
                            </div>
                            <div class="error-tip" v-if="error.companyTax">{{ error.companyTax ? error.companyTax :
                                '\u00A0' }}</div>
                        </div>
                        <template v-if="addForm.invoiceType === '2'">
                            <div class="form-row">
                                <div class="input-group">
                                    <label><span class="required">*</span> 注册地址：</label>
                                    <input v-model="addForm.companyAddress" placeholder="请输入注册地址..." />
                                </div>
                                <div class="error-tip" v-if="error.companyAddress">{{ error.companyAddress ?
                                    error.companyAddress : '\u00A0' }}
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="input-group">
                                    <label><span class="required">*</span> 注册电话：</label>
                                    <input v-model="addForm.phoneNumber" placeholder="请输入注册电话..." />
                                </div>
                                <div class="error-tip" v-if="error.phoneNumber">{{ error.phoneNumber ? error.phoneNumber
                                    : '\u00A0' }}</div>
                            </div>
                            <div class="form-row">
                                <div class="input-group">
                                    <label><span class="required">*</span> 开户银行：</label>
                                    <input v-model="addForm.bankName" placeholder="请输入开户银行..." />
                                </div>
                                <div class="error-tip" v-if="error.bankName">{{ error.bankName ? error.bankName :
                                    '\u00A0' }}</div>
                            </div>
                            <div class="form-row">
                                <div class="input-group">
                                    <label><span class="required">*</span> 开户账户：</label>
                                    <input v-model="addForm.bankCard" placeholder="请输入开户账号..." />
                                </div>
                                <div class="error-tip" v-if="error.bankCard">{{ error.bankCard ? error.bankCard :
                                    '\u00A0' }}</div>
                            </div>
                        </template>
                        <div class="form-row">
                            <div class="input-group">
                                <label><span class="required">*</span> 发票邮箱：</label>
                                <input v-model="addForm.receiveEmail" placeholder="请输入发票邮箱..." />
                            </div>
                            <div class="error-tip" v-if="error.receiveEmail">{{ error.receiveEmail ? error.receiveEmail
                                : '\u00A0' }}</div>
                        </div>
                        <div class="form-row checkbox-row">
                            <div class="input-group">
                                <label>是否默认：</label>
                                <label class="checkbox-label label-width">
                                    <input type="checkbox" v-model="addForm.isDefault" /> <span>作为默认发票</span>
                                </label>
                            </div>
                            <div class="error-tip"></div>
                        </div>
                    </div>
                    <div class="modal-btns">
                        <button type="button" class="modal-cancel" @click="showAddModal = false">取消</button>
                        <button type="submit" class="modal-save">保存</button>
                    </div>
                </form>
            </div>
        </div>
        <!-- 新增暂不开票弹窗 -->
        <div v-if="showNoInvoiceDialog" class="no-invoice-dialog-mask">
            <div class="no-invoice-dialog">
                <div class="no-invoice-title">温馨提示</div>
                <div class="no-invoice-content">付款后，您可在<a href="javascript:void(0);" class="custom-dialog-link"
                        @click="goToPersonCenter">个人中心</a>/我的订单中开具发票。</div>
                <button class="no-invoice-btn" @click="confirmNoInvoice">提交订单</button>
            </div>
        </div>
        <!-- 已下单 重复下单提示 -->
        <div v-if="doubleBooking" class="no-invoice-dialog-mask">
            <div class="no-invoice-dialog">
                <div class="no-invoice-title">温馨提示</div>
                <div class="no-invoice-content">订单已生成，请前往<a href="javascript:void(0);" class="custom-dialog-link"
                        @click="goToPersonCenter">个人中心</a>查看订单并完成付款。</div>
                <button class="no-invoice-btn" @click="doubleBooking = false">我已知悉</button>
            </div>
        </div>
    </div>
</template>
<script>
import navbar from '@/components/nav.vue'
import stepBar from '@/components/step-bar.vue'
import { userInvoice, addUserInvoice, companyInvoice, addOrder } from '@/api/api'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
export default {
    name: "Invoice",
    components: {
        navbar,
        stepBar
    },
    data() {
        return {
            tabType: 'personal',
            // 个人tab数据
            personalList: [],
            selectedPersonalIdx: 0,
            defaultPersonalIdx: 0,
            // 单位tab数据
            companyList: [],
            selectedCompanyIdx: 0,
            defaultCompanyIdx: 0,
            // 弹窗相关
            showAddModal: false,
            showNoInvoiceDialog: false,
            // 路由参数
            routeParams: null,
            // 单位
            addForm: {
                invoiceType: '1', // normal 普票 special 专票
                companyName: '',
                companyTax: '',
                companyAddress: '',
                phoneNumber: '',
                bankName: '',
                bankCard: '',
                receiveEmail: '',
                isDefault: 0
            },
            // 个人
            personalFrom: {
                companyName: '',
                phoneNumber: '',
                receiveEmail: '',
                invoiceType: '3',
                isDefault: 0
            },
            error: {},
            doubleBooking: false
        }
    },
    computed: {
        // 获取当前选中的发票ID
        selectedInvoiceId() {
            if (this.tabType === 'personal') {
                return this.personalList[this.selectedPersonalIdx]?.id || '';
            } else {
                return this.companyList[this.selectedCompanyIdx]?.id || '';
            }
        }
    },
    watch: {
        tabType(newVal) {
            this.error = {};
            if (newVal == 'company') {
                this.getCompanytInvoice();
            } else {
                this.getUserInvoice();
            }
        },
        'addForm.invoiceType'(newVal) {
            this.error = {};
            if (newVal === '1') {
                // 切换为普票，清空专票相关字段
                this.addForm.companyAddress = '';
                this.addForm.phoneNumber = '';
                this.addForm.bankName = '';
                this.addForm.bankCard = '';
            }
        }
    },
    methods: {
        // 获取邮箱列标题
        getEmailColumnTitle() {
            if (this.tabType === 'personal') {
                return '邮箱';
            } else if (this.tabType === 'company' && this.companyList.length > 0) {
                return '发票邮箱';
            }
            return '';
        },
        goToPersonCenter() {
            this.showNoInvoiceDialog = false;
            this.doubleBooking = false;
            this.$router.push({ path: '/person/order' });
        },
        //获取姓名公司名称列标题
        getNameColumnTitle() {
            if (this.tabType === 'personal') {
                return '姓名';
            } else if (this.tabType === 'company' && this.companyList.length > 0) {
                return '公司名称';
            }
            return '';
        },
        // 获取电话列标题
        getPhoneColumnTitle() {
            if (this.tabType === 'personal') {
                return '手机号';
            } else if (this.tabType === 'company' && this.companyList.length > 0) {
                const firstItem = this.companyList[0];
                // return firstItem.invoiceType === '1' ? '公司税号' : '注册电话';
                return firstItem.invoiceType === '1' ? '公司税号' : '公司税号';
            }
            return '';
        },
        //查询个人发票
        getUserInvoice() {
            userInvoice().then((res) => {
                if (res.code == 200) {
                    this.personalList = res.data || [];
                    // 设置默认选中项
                    const defaultIdx = this.personalList.findIndex(item => item.isDefault === '1');
                    if (defaultIdx !== -1) {
                        this.selectedPersonalIdx = defaultIdx;
                    }
                }
            })
        },
        //查询单位发票
        getCompanytInvoice() {
            companyInvoice().then((res) => {
                if (res.code == 200) {
                    this.companyList = res.data || [];
                    // 设置默认选中项
                    const defaultIdx = this.companyList.findIndex(item => item.isDefault === '1');
                    if (defaultIdx !== -1) {
                        this.selectedCompanyIdx = defaultIdx;
                    }
                }
            })
        },
        selectPersonal(idx) {
            this.selectedPersonalIdx = idx
        },
        selectCompany(idx) {
            this.selectedCompanyIdx = idx
        },
        openAddModal() {
            this.showAddModal = true;
            this.error = {};
            if (this.tabType === 'personal') {
                this.personalFrom = {
                    companyName: '',
                    phoneNumber: '',
                    receiveEmail: '',
                    invoiceType: '3',
                    isDefault: 0
                };
            } else {
                this.addForm = {
                    invoiceType: '1',
                    companyName: '',
                    companyTax: '',
                    companyAddress: '',
                    phoneNumber: '',
                    bankName: '',
                    bankCard: '',
                    receiveEmail: '',
                    isDefault: 0
                };
            }
        },
        handleSave() {
            this.error = {};
            let valid = true;
            if (this.tabType === 'company') {
                if (!this.addForm.companyName) {
                    this.error.companyName = '公司名称不能为空';
                    valid = false;
                }
                if (!this.addForm.companyTax) {
                    this.error.companyTax = '公司税号不能为空';
                    valid = false;
                } else if (this.addForm.companyTax.trim().length !== 18) {
                    this.error.companyTax = '公司税号必须为18位';
                    valid = false;
                }
                if (!this.addForm.receiveEmail) {
                    this.error.receiveEmail = '发票邮箱不能为空';
                    valid = false;
                }
                if (this.addForm.receiveEmail && !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(this.addForm.receiveEmail)) {
                    this.error.receiveEmail = '邮箱格式不正确';
                    valid = false;
                }
                if (this.addForm.companyTax && !/^[A-Z0-9]{15,20}$/.test(this.addForm.companyTax)) {
                    this.error.companyTax = '税号格式不正确';
                    valid = false;
                }
                if (this.addForm.invoiceType === '2') {
                    if (!this.addForm.companyAddress) {
                        this.error.companyAddress = '注册地址不能为空';
                        valid = false;
                    }
                    if (!this.addForm.phoneNumber) {
                        this.error.phoneNumber = '注册电话不能为空';
                        valid = false;
                    }
                    if (!this.addForm.bankName) {
                        this.error.bankName = '开户银行不能为空';
                        valid = false;
                    }
                    if (!this.addForm.bankCard) {
                        this.error.bankCard = '开户账户不能为空';
                        valid = false;
                    }
                }
            } else {
                if (!this.personalFrom.companyName) {
                    this.error.companyName = '姓名不能为空';
                    valid = false;
                }
                if (!this.personalFrom.receiveEmail) {
                    this.error.receiveEmail = '邮箱不能为空';
                    valid = false;
                }
                // 新增邮箱格式校验
                if (this.personalFrom.receiveEmail && !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(this.personalFrom.receiveEmail)) {
                    this.error.receiveEmail = '邮箱格式不正确';
                    valid = false;
                }
                if (!this.personalFrom.phoneNumber) {
                    this.error.phoneNumber = '手机号不能为空';
                    valid = false;
                }
                if (this.personalFrom.phoneNumber && !/^1\d{10}$/.test(this.personalFrom.phoneNumber)) {
                    this.error.phoneNumber = '手机号格式不正确';
                    valid = false;
                }
            }
            if (!valid) return;
            if (this.tabType === 'personal') {
                const params = {
                    companyName: this.personalFrom.companyName,
                    phoneNumber: this.personalFrom.phoneNumber,
                    receiveEmail: this.personalFrom.receiveEmail,
                    invoiceType: this.personalFrom.invoiceType,
                    isDefault: this.personalFrom.isDefault ? '1' : '0'
                };
                addUserInvoice(params).then((res) => {
                    if (res.code == 200) {
                        Message.success('个人发票添加成功');
                        this.showAddModal = false;
                        this.getUserInvoice();
                    } else {
                        Message.error(res.msg || '添加失败');
                    }
                }).catch(err => {
                    Message.error('添加失败，请稍后重试');
                })
            } else {
                if (this.addForm.invoiceType === '2') {//专票
                    var params = {
                        "invoiceType": this.addForm.invoiceType,
                        "companyName": this.addForm.companyName,
                        "companyTax": this.addForm.companyTax,
                        "companyAddress": this.addForm.companyAddress,
                        "phoneNumber": this.addForm.phoneNumber,
                        "bankName": this.addForm.bankName,
                        "isDefault": this.addForm.isDefault ? '1' : '0',
                        "bankCard": this.addForm.bankCard,
                        "receiveEmail": this.addForm.receiveEmail
                    };
                } else {
                    var params = { //普票
                        companyName: this.addForm.companyName,
                        companyTax: this.addForm.companyTax,
                        invoiceType: this.addForm.invoiceType,
                        receiveEmail: this.addForm.receiveEmail,
                        isDefault: this.addForm.isDefault ? '1' : '0'
                    }
                }

                addUserInvoice(params).then((res) => {
                    if (res.code == 200) {
                        Message.success('单位发票添加成功');
                        this.showAddModal = false;
                        this.getCompanytInvoice();
                    } else {
                        Message.error(res.msg || '添加失败');
                    }
                }).catch(err => {
                    Message.error('添加失败，请稍后重试');
                })
            }
        },
        // 暂不开票
        handleNoInvoice() {
            this.showNoInvoiceDialog = true;
        },
        // 新增：确认暂不开票，执行原有下单逻辑
        confirmNoInvoice() {
            this.showNoInvoiceDialog = false;
            const params = {
                addressId: this.routeParams.addressId,
                goods: JSON.parse(window.localStorage.getItem('goods'))
                // goods: this.routeParams.goods.map(item => ({
                //     goodsId: item.goodsId,
                //     quantity: String(item.quantity) // 确保quantity是字符串类型
                // }))
            };
            // 调用创建订单接口
            addOrder(params).then(res => {
                if (res.code === 200) {
                    window.localStorage.removeItem('goods');
                    this.$router.push({
                        path: '/payment',
                        query: { orderId: res.data }
                    });
                }else if(res.code === 400){
                    Message.error(res.msg);
                } else {
                    this.doubleBooking = true;
                }
            }).catch(err => {
                Message.error('创建订单失败，请稍后重试');
            });
        },
        // 确认开票
        next() {
            // 检查是否有可用的发票
            if ((this.tabType === 'personal' && this.personalList.length === 0) ||
                (this.tabType === 'company' && this.companyList.length === 0)) {
                Message.warning('请先填写发票信息');
                return;
            }

            const params = {
                addressId: this.routeParams.addressId,
                invoiceId: this.selectedInvoiceId,
                goods: JSON.parse(window.localStorage.getItem('goods'))
                // goods: this.routeParams.goods.map(item => ({
                //     goodsId: item.goodsId,
                //     quantity: String(item.quantity) // 确保quantity是字符串类型
                // }))
            };
            // 调用创建订单接口
            addOrder(params).then(res => {
                if (res.code === 200) {
                    window.localStorage.removeItem('goods');
                    this.$router.push({
                        path: '/payment',
                        query: { orderId: res.data }
                    });
                } else if(res.code === 400){
                    Message.error(res.msg);
                } else {
                    // Message.error(res.msg || '订单已生成，请前往个人中心查看订单并完成付款。');
                    this.doubleBooking = true;
                }
            }).catch(err => {
                Message.error('创建订单失败，请稍后重试');
            });
        }
    },
    mounted() {
        // 获取路由参数
        const queryData = this.$route.query.data;
        if (queryData) {
            this.routeParams = JSON.parse(queryData);
        }
        this.getUserInvoice();
    }
}
</script>
<style scoped>
.Invoice {
    background-image: url('@/assets/images/home/container-bg.png');
    background-size: cover;
    min-height: 100vh;
    background-repeat: no-repeat;
    padding-bottom: 100px;
    height: 100%;
}

.invoice-container {
    margin-top: 30px;
    width: var(--main-width);
    margin: 0 auto;
}

.tab-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tab-tips {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    background: #F1EDC3;
    padding: 12.5px;
    margin-top: 8px;
    border-radius: 5px;
    color: #827932;
}

.tab-tips p {
    margin: 0;
}

.selected-invoice {
    display: flex;
    justify-content: space-between;
    font-size: 20px;
    align-items: center;
}


.selected-invoice span {
    font-weight: bold;
}

.add-btn {
    background: #2765D5;
    color: #fff;
    border: none;
    padding: 8px 28px;
    border-radius: 5px;
    font-size: 16px;
    margin-right: 30px;
    cursor: pointer;
}

.tabs {
    display: flex;
    margin: 30px 0 0 0;
}

.tab {
    width: 200px;
    text-align: center;
    padding: 12px 0;
    font-size: 16px;
    background: #BEBDC0;
    border-radius: 10px 10px 0 0;
    margin-right: 24px;
    cursor: pointer;
    font-weight: 500;
    color: #fff;
    transition: background 0.2s, color 0.2s;
    font-weight: bold;
}

.tab.active {
    background: #2865D4;
    color: #fff;
}

.invoice-list {
    margin: 0;
    background: rgba(246, 248, 250, 0.8);
    border-radius: 5px;
    padding: 10px 0 60px 0;
}

.invoice-header {
    display: flex;
    align-items: center;
    min-height: 64px;
    font-size: 20px;
    color: #222;
    border: none;
    box-shadow: none;
    border-bottom: 1px solid #bdbdbd;
    transition: background 0.2s, color 0.2s, border 0.2s;
    font-weight: bold;
    margin: 0 40px;
}

.invoice-item {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 64px;
    font-size: 20px;
    color: #222;
    border: none;
    box-shadow: none;
    border-bottom: 1px solid #bdbdbd;
    transition: background 0.2s, color 0.2s, border 0.2s;
    /* font-weight: bold; */
    margin: 0 40px;
    cursor: pointer;
}

.invoice-container-left {
    justify-content: left !important;
}

.invoice-item:last-child {
    border-bottom: 1.5px solid #bdbdbd;
}

.invoice-item.selected {
    background: #1677ff;
    color: #fff;
}

.col {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 64px;
    padding: 0 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 16px;
    position: relative;
}

.col:not(:first-child)::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 24px;
    background: #bdbdbd;
    margin: 0;
}

.col.name {
    width: 320px;
    flex-shrink: 0;
}

.col.email {
    min-width: 260px;
    flex-shrink: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.col.Tax {
    flex: 1;
    max-width: 260px;
    min-width: 260px;
}

.col.phone {
    width: 260px;
    flex-shrink: 0;
    min-width: 260px;
    max-width: 260px;
}

.col.radio-col {
    width: 80px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    padding-right: 0;
    padding-left: 0;
}

.custom-radio {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

.custom-radio input[type="radio"] {
    display: none;
}

.radio-mark {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
}

.footer {
    margin-top: 60px;
    text-align: center;
}

.btn-group {
    display: flex;
    justify-content: center;
    gap: 48px;
}

.cancel-btn,
.confirm-btn {
    background: #2765D5;
    color: #fff;
    border: none;
    padding: 8px 40px;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
}

.cancel-btn {
    background: #fff;
    border: 2px solid #2765D5;
    opacity: 0.8;
    color: #2765D5;
}

.modal-mask {
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-content {
    background: #fff;
    border-radius: 10px;
    padding: 25px 60px 20px 60px;
    min-width: 600px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
}

.modal-title {
    font-size: 22px;
    font-weight: bold;
    margin: 0 0 20px 0;
    text-align: center;
}

.form-row {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
}

.input-group {
    display: flex;
    align-items: center;
    flex: 1;
    width: 100%;
    font-size: var(--fontSize);

}

.input-group label,
.form-row label,
.flex-row label,
.checkbox-row label {
    text-align: right;
    font-size: var(--fontSize);
    margin-bottom: 0;
    margin-right: 12px;
    min-width: 120px;
}

.input-group input[type="text"],
.input-group input[type="email"],
.input-group input[type="tel"],
.input-group input[type="number"],
.input-group input[type="password"],
.input-group input:not([type]),
.input-group input {
    height: 34px;
    border: 1px solid #bfcbd9;
    border-radius: 4px;
    padding: 0 12px;
    font-size: var(--fontSize);
    outline: none;
    flex: 1;
}

.input-group input[type='radio'] {
    flex: 0.2;
}

.input-group input[type='checkbox'] {
    height: 20px;
}



.error-tip {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 2px;
    width: 335px;
}

.modal-btns {
    display: flex;
    justify-content: center;
    gap: 48px;
    margin-top: 32px;
}

.modal-cancel,
.modal-save {
    font-size: 16px;
    padding: 10px 48px;
    border-radius: 8px;
    border: 2px solid #2765D5;
    background: #fff;
    color: #1677ff;
    cursor: pointer;
}

.modal-save {
    background: #2765D5;
    color: #fff;
}

.radio-row {
    align-items: center;
}

.radio-group {
    display: flex;
    align-items: center;
    gap: 32px;
    flex-direction: row !important;
}

.radio-label {
    display: flex;
    align-items: center;
    font-size: 20px;
    margin-right: 24px;
}

.checkbox-row {
    align-items: center;
}

.checkbox-label {
    display: flex;
    align-items: center;
    font-size: 18px;
    margin-left: 0;
    gap: 6px;
}

.checkbox-label span {
    margin-left: 2px;
}

.label-width {
    width: max-content;
}

.no-invoice-dialog-mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.15);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.no-invoice-dialog {
    background: #fff;
    border-radius: 18px;
    min-width: 400px;
    padding: 40px 36px 36px 36px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.no-invoice-title {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 18px;
    text-align: center;
}

.no-invoice-content {
    font-size: 16px;
    color: #333;
    margin-bottom: 32px;
    text-align: center;
}

.no-invoice-btn {
    background: #2865D4;
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 10px 60px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
}

/* 空状态样式 */
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0 0 0px;
    text-align: center;
}

.empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.6;
}

.empty-text {
    font-size: 18px;
    color: #666;
    margin-bottom: 24px;
    font-weight: 500;
}

.fill-invoice-btn {
    background: #2765D5;
    color: #fff;
    border: none;
    padding: 12px 32px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
}

.fill-invoice-btn:hover {
    background: #1e4fa8;
}

/* 禁用状态的确认开票按钮 */
.confirm-btn:disabled {
    background: #ccc;
    color: #999;
    cursor: not-allowed;
    border: none;
}

.confirm-btn:disabled:hover {
    background: #ccc;
}

.custom-dialog-link {
    color: #2865D4;
    text-decoration: underline;
    cursor: pointer;
}
</style>